"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterSelect = exports.useClickOutside = void 0;
const react_1 = __importStar(require("react"));
const vobaza_ui_icon_1 = require("@nebo-team-dev/vobaza.ui.icon");
const vobaza_ui_button_1 = require("@nebo-team-dev/vobaza.ui.button");
const vobaza_ui_inputs_input_checkbox_1 = require("@nebo-team-dev/vobaza.ui.inputs.input-checkbox");
const vobaza_ui_range_1 = require("@nebo-team-dev/vobaza.ui.range");
const filter_select_styled_1 = require("./filter-select.styled");
const useClickOutside = (ref, callback) => {
    (0, react_1.useEffect)(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setTimeout(() => callback(event), 10);
            }
        }
        const body = document.querySelector('body');
        if (body) {
            body.addEventListener('mousedown', handleClickOutside);
            body.addEventListener('touchend', handleClickOutside);
            return () => {
                body.removeEventListener('mousedown', handleClickOutside);
                body.removeEventListener('touchend', handleClickOutside);
            };
        }
    }, [ref, callback]);
};
exports.useClickOutside = useClickOutside;
const getValueText = (variants) => {
    var _a, _b;
    if (!variants)
        return null;
    if (Array.isArray(variants)) {
        if (variants.length > 1)
            return (react_1.default.createElement(react_1.default.Fragment, null, (_a = variants[0]) === null || _a === void 0 ? void 0 :
                _a.value,
                ' ',
                react_1.default.createElement("span", { style: { color: 'var(--primary-color,#367bf5)' } },
                    "\u0438 \u0435\u0449\u0451 ",
                    variants.length - 1)));
        return (_b = variants[0]) === null || _b === void 0 ? void 0 : _b.value;
    }
    return variants.value;
};
const FilterSelect = (_a) => {
    var { variants = [], selected = null, variation = 'primary', type = 'text', placeholder = 'Выберите из списка', onChange = () => { }, withSearch = false, isRightSide = false, buttonText, onButtonClick, values, onReset, incomeValues, setIncomeValues, lockAfterUnchecked, disabled, onlyPlaceholder } = _a, props = __rest(_a, ["variants", "selected", "variation", "type", "placeholder", "onChange", "withSearch", "isRightSide", "buttonText", "onButtonClick", "values", "onReset", "incomeValues", "setIncomeValues", "lockAfterUnchecked", "disabled", "onlyPlaceholder"]);
    const selectRef = (0, react_1.useRef)(null);
    const [currentVariants, setCurrentVariants] = (0, react_1.useState)([]);
    const [isShow, setIsShow] = (0, react_1.useState)(false);
    const [search, setSearch] = (0, react_1.useState)('');
    const handleClickVariant = (variant) => {
        onChange(variant);
        setIsShow(false);
    };
    const buttonClickHandler = (values) => {
        setIsShow(!isShow);
        if (values) {
            onButtonClick && onButtonClick(values);
        }
        else {
            onButtonClick && onButtonClick();
        }
    };
    const toggleMenu = () => {
        setIsShow(!isShow);
    };
    const setSearchHandler = (e) => {
        setSearch(e.target.value);
    };
    (0, react_1.useEffect)(() => {
        if (search) {
            const newVariants = variants.filter((variant) => variant.value.toString().toLowerCase().includes(search.toLowerCase()));
            return setCurrentVariants(newVariants);
        }
        setCurrentVariants([...variants]);
    }, [search]);
    (0, react_1.useEffect)(() => {
        if (search) {
            const newVariants = variants.filter(({ value }) => {
                const _search = search.toLowerCase();
                return value.toString().toLowerCase().includes(_search);
            });
            setCurrentVariants([...newVariants]);
        }
        else {
            setCurrentVariants([...variants]);
        }
    }, [variants]);
    (0, react_1.useEffect)(() => {
        setSearch('');
    }, [isShow]);
    (0, exports.useClickOutside)(selectRef, () => {
        setIsShow(false);
    });
    const renderVariant = (variant) => {
        if (type === 'text')
            return (react_1.default.createElement(filter_select_styled_1.StyledVariant, { key: variant.code, type: "button", "data-variation": variation, onClick: () => handleClickVariant(variant) }, variant.value));
        else if (type === 'checkbox')
            return (react_1.default.createElement(filter_select_styled_1.StyledVariant, { key: variant.code, type: "button", "data-variation": variation },
                react_1.default.createElement(filter_select_styled_1.CheckboxContainer, null,
                    react_1.default.createElement(vobaza_ui_inputs_input_checkbox_1.InputCheckbox, { variation: variation, label: variant.value, initialValue: variant.isActive, onChange: (val) => onChange(Object.assign(Object.assign({}, variant), { isActive: val })), disabled: lockAfterUnchecked
                            ? lockAfterUnchecked && variant.isActive
                                ? false
                                : variant.disabled
                            : variant.disabled }),
                    variant.disabled && lockAfterUnchecked && (react_1.default.createElement(filter_select_styled_1.LockIconWrapper, { title: "\u042D\u0442\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0434\u0440\u0443\u0433\u0438\u043C \u0444\u0438\u043B\u044C\u0442\u0440\u043E\u043C" },
                        react_1.default.createElement(vobaza_ui_icon_1.Icon, { name: "Lock", style: { color: 'gray' } }))))));
    };
    const valueText = getValueText(selected || variants.filter(({ isActive }) => isActive));
    return (react_1.default.createElement(filter_select_styled_1.StyledWrapper, Object.assign({ ref: selectRef, "data-variation": variation, "data-active": isShow }, props),
        react_1.default.createElement(filter_select_styled_1.StyledValue, { "data-variation": variation, "data-selected": isShow, onClick: toggleMenu },
            onlyPlaceholder ? (react_1.default.createElement("span", null, placeholder)) : (react_1.default.createElement("span", null, valueText || placeholder)),
            react_1.default.createElement(vobaza_ui_icon_1.Icon, { name: isShow ? 'SmallArrowUp' : 'SmallArrowDown' })),
        isShow && (react_1.default.createElement(filter_select_styled_1.StyledVariants, { "data-variation": variation, show: isShow, right: isRightSide },
            react_1.default.createElement(filter_select_styled_1.StyledVariantsWrapper, null,
                withSearch && (react_1.default.createElement("div", { style: { width: 'calc(100% - 16px)', margin: '0px 8px 8px' } },
                    react_1.default.createElement(filter_select_styled_1.StyledSearch, { name: "filter-select", value: search, onChange: setSearchHandler, isColoredIcon: true, icon: "Magnifier", placeholder: "\u041F\u043E\u0438\u0441\u043A", autoComplete: "off", autoFocus: true }))),
                react_1.default.createElement(filter_select_styled_1.StyledVariantsBlock, null,
                    type === 'checkbox' && onReset && (react_1.default.createElement(filter_select_styled_1.StyledResetButton, { onClick: onReset }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0432\u0441\u0451")),
                    type === 'range' ? (react_1.default.createElement(filter_select_styled_1.StyledRange, null,
                        react_1.default.createElement(vobaza_ui_range_1.RangeBlock, { min: +variants[0].value, max: +variants[1].value, buttonText: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C", incomeValues: incomeValues, setIncomeValue: setIncomeValues, buttonClickHandler: buttonClickHandler, disabled: disabled }))) : currentVariants.length > 0 ? (currentVariants.map((variant) => renderVariant(variant))) : (react_1.default.createElement(filter_select_styled_1.StyledEmptyVariants, null, "\u041F\u043E \u044D\u0442\u0438\u043C \u043A\u0440\u0438\u0442\u0435\u0440\u0438\u044F\u043C \u043F\u043E\u0438\u0441\u043A\u0430 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E")))),
            buttonText && type !== 'range' && (react_1.default.createElement(filter_select_styled_1.StyledVariantsButton, null,
                react_1.default.createElement(vobaza_ui_button_1.Button, { text: buttonText, onClick: buttonClickHandler })))))));
};
exports.FilterSelect = FilterSelect;
//# sourceMappingURL=filter-select.js.map